module.exports = __webpack_public_path__ + "static/media/rm_06-36.adaa36f3.png";